import {MOBILE_MODE_MEDIA_QUERY} from '../constants';
import useMediaQuery from './useMediaQuery';

export function useMobileMode(): boolean {
  const compactMode = useMediaQuery(MOBILE_MODE_MEDIA_QUERY);

  return compactMode;
}

export default useMobileMode;